var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "examSignIn" }, [
    _c("div", { staticClass: "examSignIn-box" }, [
      _c("div", { staticClass: "printCont" }, [
        _c("div", { ref: "print-content", attrs: { id: "printCont" } }, [
          _c("div", { staticClass: "logo" }, [
            _c("img", {
              staticClass: "img",
              attrs: {
                src: require("@/assets/images/cqjtdxLogo.png"),
                alt: "",
              },
            }),
          ]),
          _c("div", { staticClass: "student-info" }, [
            _c("div", { staticClass: "info-l" }, [
              _c("img", {
                staticClass: "img",
                attrs: { src: _vm.info.student_thumb, alt: "" },
              }),
            ]),
            _c("div", { staticClass: "info-r" }, [
              _c("p", { staticClass: "info-r-t item cell title" }, [
                _vm._v("考籍档案基本信息"),
              ]),
              _c("p", { staticClass: "item" }, [
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("准考证"),
                ]),
                _c("span", { staticClass: "cell w-24 b-r" }, [
                  _vm._v(_vm._s(_vm.info.exam_number)),
                ]),
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("姓名"),
                ]),
                _c("span", { staticClass: "cell w-20 b-r" }, [
                  _vm._v(_vm._s(_vm.info.student_title)),
                ]),
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("性别"),
                ]),
                _c("span", { staticClass: "cell w-14" }, [
                  _vm._v(_vm._s(_vm.info.sex_title)),
                ]),
              ]),
              _c("p", { staticClass: "item" }, [
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("身份证"),
                ]),
                _c("span", { staticClass: "cell w-24 b-r" }, [
                  _vm._v(_vm._s(_vm.info.identity)),
                ]),
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("民族"),
                ]),
                _c("span", { staticClass: "cell w-20 b-r" }, [
                  _vm._v(_vm._s(_vm.info.nation)),
                ]),
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("籍贯"),
                ]),
                _c("span", { staticClass: "cell w-14" }, [
                  _vm._v(_vm._s(_vm.info.office)),
                ]),
              ]),
              _c("p", { staticClass: "item" }, [
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("建档专业"),
                ]),
                _c("span", { staticClass: "cell w-38 b-r" }, [
                  _vm._v(_vm._s(_vm.info.profession_title)),
                ]),
                _c("span", { staticClass: "title cell w-20 b-r" }, [
                  _vm._v("层次"),
                ]),
                _c("span", { staticClass: "cell w-28" }, [
                  _vm._v(_vm._s(_vm.info.level)),
                ]),
              ]),
              _c("p", { staticClass: "item" }, [
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("地址"),
                ]),
                _c("span", { staticClass: "cell w-85" }, [
                  _vm._v(_vm._s(_vm.info.address)),
                ]),
              ]),
              _c("p", { staticClass: "item" }, [
                _c("span", { staticClass: "title cell w-14 b-r" }, [
                  _vm._v("电话"),
                ]),
                _c("span", { staticClass: "cell w-85" }, [
                  _vm._v(_vm._s(_vm.info.mobile)),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "notice" },
            [
              _c("div", { staticClass: "notice-title" }, [
                _vm._v(_vm._s(_vm.info.exam_title)),
              ]),
              _c("div", { staticClass: "notice-t" }, [
                _c("span", { staticClass: "notice-t-text" }, [
                  _vm._v("准考证号：" + _vm._s(_vm.info.exam_number)),
                ]),
                _c("span", { staticClass: "notice-t-text" }, [
                  _vm._v("姓名：" + _vm._s(_vm.info.student_title)),
                ]),
                _c("span", { staticClass: "notice-t-text tips" }, [
                  _vm._v("请带上身份证和打印的考签"),
                ]),
              ]),
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: { data: _vm.info.exam_arr, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "exam_time",
                      label: "考试时间",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "course_title",
                      label: "考试课程",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "exam_address",
                      label: "考试地点",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "room_sn", label: "考场", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "seat_number",
                      label: "座位",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
              _c("div", {
                staticClass: "tips-b",
                domProps: { innerHTML: _vm._s(_vm.info.exam_notice) },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "btn no-print" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isPrint,
                    expression: "!isPrint",
                  },
                ],
                attrs: { type: "primary" },
                on: { click: _vm.print },
              },
              [_vm._v("打印")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }